import {
  GridReportMetadata,
  GridReportMetadataBucket,
} from '../components/widget-grid/widget-grid.component';

export class ChartHelper {
  public getTopAssociatedLabel(metadata: GridReportMetadata[], breakdown: string): string {
    //This function exists to make sure that when a breakdown has conflicting or multiple top associated values that the one with the same name as the breakdown is chosen. DASH-7199
    const labels = metadata.find((x) => x.scoreType === 'COMMON_VALUES')?.buckets;
    //Taxonomy
    if (!labels) {
      return breakdown;
    }

    let topSorter: GridReportMetadataBucket[] = [];
    let maxValue = 0;
    for (const obj of labels) {
      if (obj.count > maxValue) {
        maxValue = obj.count;
        topSorter = [obj];
      } else if (obj.count === maxValue) {
        topSorter.push(obj);
      }
    }

    return topSorter.find((x) => x.label === breakdown)?.label || topSorter[0].label;
  }
}
